import { Falcon } from 'modules/macro';
import { IconButton } from 'modules/v2/navigation/buttons';
import { VisuallyHidden } from 'modules/visually-hidden';
export function ScrollButton(props) {
    const { direction, label, onClick } = props;
    return (<IconButton appearance="ghost" size="small" onClick={onClick}>
      {direction === 'left' ? <Falcon icon="chevron-left"/> : <Falcon icon="chevron-right"/>}
      <VisuallyHidden>{label}</VisuallyHidden>
    </IconButton>);
}
